import React from 'react';
import DataTable from 'react-data-table-component';
import HighlightBanner from '../../components/HighlightedBanner/HighlightBanner';
import { columns } from './_components/columns';
import { Actions } from './_components/actions';
import { tableCustomStyles } from './_components/styles';
import { useItemsBootstrap } from './items.bootstrap.hook';

export function Items() {
  const {
    data,
    loading,
    errorMessage,
    totalRows,
    perPage,
    currentPage,
    filterText,
    resetPaginationToggle,
    handlePageChange,
    handlePerRowsChange,
    handleFilterChange,
  } = useItemsBootstrap();

  return (
    <div className="items-page">
      <div className="row mb-10">
        <div className="col-xl-12">
          <section className="items-surface">
            {errorMessage && (
              <div className="mb-6">
                <HighlightBanner type="error">{errorMessage}</HighlightBanner>
              </div>
            )}

            <div className="items-table-shell">
              <DataTable
                columns={columns}
                data={data}
                customStyles={tableCustomStyles}
                progressPending={loading}
                pagination
                paginationPerPage={perPage}
                paginationDefaultPage={currentPage}
                paginationServer
                paginationTotalRows={totalRows}
                paginationResetDefaultPage={resetPaginationToggle}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                subHeader
                subHeaderComponent={
                  <Actions
                    filterText={filterText}
                    onFilter={handleFilterChange}
                  />
                }
                persistTableHead
                responsive
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
